// FailPayment.js - 결제 실패 페이지 (React 웹)
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import backArrow from '../img/common/backarrow.png';
import emptyIcon from '../img/common/empty.png';
import '../styles/main.scss';

export default function FailPayment() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [errorMessage, setErrorMessage] = useState('결제에 실패했습니다.');

    useEffect(() => {
        // URL 파라미터에서 에러 메시지 추출
        const message = searchParams.get('message');
        const code = searchParams.get('code');

        if (message) {
            setErrorMessage(decodeURIComponent(message));
        } else if (code) {
            // 토스 에러 코드에 따른 메시지
            const errorMessages = {
                'PAY_PROCESS_CANCELED': '사용자가 결제를 취소했습니다.',
                'PAY_PROCESS_ABORTED': '결제 진행 중 오류가 발생했습니다.',
                'REJECT_CARD_COMPANY': '카드사에서 승인을 거부했습니다.',
                'INVALID_CARD_EXPIRATION': '카드 유효기간을 확인해주세요.',
                'INVALID_STOPPED_CARD': '정지된 카드입니다.',
                'EXCEED_MAX_CARD_AMOUNT': '한도를 초과했습니다.',
                'INVALID_CARD_INSTALLMENT_PLAN': '할부 개월 수가 잘못되었습니다.',
                'NOT_SUPPORTED_INSTALLMENT_PLAN_CARD_OR_MERCHANT': '할부가 지원되지 않는 카드 또는 가맹점입니다.',
                'INVALID_CARD_LOST_OR_STOLEN': '분실 또는 도난 카드입니다.',
                'RESTRICTED_TRANSFER_ACCOUNT': '계좌이체가 제한된 계좌입니다.',
                'INVALID_ACCOUNT_INFO_RE_REGISTER': '유효하지 않은 계좌입니다.',
                'NOT_AVAILABLE_PAYMENT': '결제가 불가능한 시간대입니다.',
            };
            setErrorMessage(errorMessages[code] || '결제에 실패했습니다.');
        }
    }, [searchParams]);

    const handleGoHome = () => {
        try {
            // RN WebView 환경인지 확인
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    action: 'GO_HOME_TAB',
                    type: 'GO_HOME_TAB'
                }));
            }
            // RN 커스텀 브리지
            else if (window.__askRN) {
                window.__askRN('GO_HOME_TAB', {});
            }
            // 웹 환경
            else {
                navigate('/');
            }
        } catch (error) {
            console.error('[FailPayment] 홈 이동 실패:', error);
            navigate('/');
        }
    };

    const handleGoBack = () => {
        try {
            // RN WebView 환경인지 확인
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    action: 'GO_BACK',
                    type: 'GO_BACK'
                }));
            }
            // RN 커스텀 브리지
            else if (window.__askRN) {
                window.__askRN('GO_BACK', {});
            }
            // 웹 환경
            else {
                navigate(-1);
            }
        } catch (error) {
            console.error('[FailPayment] 뒤로가기 실패:', error);
            navigate(-1);
        }
    };

    return (
        <div
            className="fail-payment-container"
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                backgroundColor: '#ffffff'
            }}
        >
            {/* 상단 바 */}
            <div className="top-bar">
                <div
                    className="top-bar-left"
                    onClick={handleGoBack}
                    style={{
                        cursor: 'pointer',
                        padding: '8px',
                        minWidth: '40px',
                        minHeight: '40px'
                    }}
                >
                    <img
                        src={backArrow}
                        alt="뒤로가기"
                        className="icon24"
                        style={{ pointerEvents: 'none' }}
                    />
                </div>
                <div className="top-bar-center">
                    <span className="top-txt font-noto">결제 실패</span>
                </div>
                <div className="top-bar-right"></div>
            </div>

            {/* 본문 - 중앙정렬 */}
            <div
                className="fail-payment-content"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                    padding: '40px 20px',
                    textAlign: 'center'
                }}
            >
                <img
                    src={emptyIcon}
                    alt="결제 실패"
                    className="fail-payment-icon"
                    style={{
                        width: '150px',
                        height: '150px',
                        marginBottom: '30px',
                        opacity: 0.7
                    }}
                />
                <h2
                    className="fail-payment-title font-bm"
                    style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#333333',
                        marginBottom: '16px'
                    }}
                >
                    결제에 실패했습니다
                </h2>
                <p
                    className="fail-payment-message font-noto"
                    style={{
                        fontSize: '16px',
                        color: '#666666',
                        lineHeight: '1.5',
                        marginBottom: '8px',
                        whiteSpace: 'pre-line'
                    }}
                >
                    {errorMessage}
                </p>
                <p
                    className="fail-payment-sub-message font-noto"
                    style={{
                        fontSize: '14px',
                        color: '#999999',
                        lineHeight: '1.5',
                        marginBottom: '40px'
                    }}
                >
                    다시 시도해주세요.
                </p>

                {/* 버튼도 중앙정렬 영역 안에 포함 */}
                <div className="enter-btn-box">
                    <button className="enter-btn" onClick={handleGoHome}>
                        홈으로 돌아가기
                    </button>
                </div>
            </div>
        </div>
    );
}